import React, { useEffect, useRef } from 'react';
import { connect } from 'react-redux';
import * as _ from 'lodash';
import PropTypes from 'prop-types';

import TenantSpinner from '../components/TenantSpinner';
import { createTenant, getUserData, getTenantCreationStatus, redirectToTenant, getUserProfile } from '../actions';
import { BLUEXP_CONFIG } from '../Auth/bluexp-variables';
import {
    MARKETING,
    CREATE_TENANT_LOCK,
    CREATING_TENANT_LOCK_COOKIE_MAXAGE,
    CREATING_TENANT_COOKIE_PREFIX,
    TENANT_LOCATION_LOCK, UI_MODE,
} from '../common/constants';
import ErrorPage from '../components/error/ErrorPage';
import { getRedirectTenantInfo } from './utils';
import {
    ThankYouMessage,
    TenantCreationFailedMessage,
    InvalidRegistrationFormMessage,
    NetAppEmployeeRestrictedMessage,
    InvalidEmailMessage,
    EmailValidatedFailedMessage,
    SsoNotAllowNonNetAppEmployeeMessage,
} from '../components/error/ErrorMessagesComps';
import {
    serverLog,
    setTenantCreationCookie,
    removeCookie,
    genCookieNameById,
    isCookieExisted,
    getJsonQueryString,
    cigDecode,
    setCookie, jsonToBase64String, base64ToJson,
    removeTenantLocationLock,
} from '../common/utils';

import {
    tenantInfo,
    userData,
    userTenantDetailsList,
    registrationInfo,
    userProfileInfo,
    createTenantErrorInfo,
    tenantCreationFailed,
    selectedLocation,
} from './selectors';

window.autoRefreshId = undefined;

const removeCreateTenantCookie = (subject) => {
    const ckName = genCookieNameById(subject, CREATING_TENANT_COOKIE_PREFIX);
    if (isCookieExisted(ckName)) {
        removeCookie(ckName);
    }
    if (isCookieExisted(CREATE_TENANT_LOCK)){
        removeCookie(CREATE_TENANT_LOCK);
    }
};

const getTenantLocationLock = (auth) => {
    let location = {};
    if (!_.isNil(sessionStorage[TENANT_LOCATION_LOCK.toString()])) {
        location = base64ToJson(sessionStorage.getItem(TENANT_LOCATION_LOCK));
        if (_.isEmpty(location)) {
            const message = 'CigTenantCreationPage: getTenantLocationLock - Failed base64 to Json. Fail to get tenant location lock value from session.' +
                ' Raw value: ' + sessionStorage[TENANT_LOCATION_LOCK.toString()];
            const error = {
                category: 'ERROR',
                logMessage: message,
            };
            serverLog(auth, error);
            return {};
        }
    }
    return location;
};

const setTenantLocationLock = (tenantLocation) => {
    if (!_.isNil(tenantLocation) && !_.isEmpty(tenantLocation)) {
        sessionStorage.setItem(TENANT_LOCATION_LOCK, jsonToBase64String(tenantLocation));
    }
};


export const renderError = (props, error) => {
    // Can not check for props.errorInfo.errorMessage here since tenant creation with failed status does not throw error.
    if (error || (!_.isEmpty(props.errorInfo) && (!_.isEmpty(props.errorInfo.errorMessage) || !_.isEmpty(props.errorInfo.httpStatusCode)))) {
        resetRefreshId();
    }
    if (props.errorInfo.httpStatusCode === 503) {
        window.history.pushState({}, null, window.location.href);
        const title = 'Thank you for your interest in NetApp Data Infrastructure Insights.';
        if (props.errorInfo.errorCode === 1151) {
            return <ErrorPage id="self-not-available-error" title={title} serverMsg={props.errorInfo.errorMessage}
                errorCode={props.errorInfo.errorCode}
                httpStatusCode={props.errorInfo.httpStatusCode} auth={window.auth}
                logPrefix='CigTenantCreationPage:' >

                <ThankYouMessage email={props.userData.email} />
            </ErrorPage>
        }
        else if (props.errorInfo.errorCode === 1231) {
            return <ErrorPage id="tenant-creation-error" title={title} serverMsg={props.errorInfo.errorMessage} errorCode={props.errorInfo.errorCode}
                httpStatusCode={props.errorInfo.httpStatusCode}
                auth={window.auth} logPrefix='CigTenantCreationPage:'>

                <TenantCreationFailedMessage email={props.userData.email} />
            </ErrorPage>
        }
    }

    if (props.errorInfo.httpStatusCode === 400) {
        if (props.errorInfo.errorCode === 1121) {
            window.CIG_LOG.warn('Gateway: Failed to create tenant: required form data.');
            // CIS-2686: Hiding Eloqua form from UI
            // return (
            //     <Redirect id='redirect_signup_form' to={{
            //         pathname: '/signup',
            //         state: {
            //             id: _.isUndefined(this.props.userData) ? '' : this.props.userData.subject
            //         }
            //     }} />
            // );
        }
        else if (props.errorInfo.errorCode === 1122) {
            return <ErrorPage id="missing-reg-error" title="Start Free Trial form have invalid or missing fields" showCIContact={true}
                serverMsg={props.errorInfo.errorMessage} errorCode={props.errorInfo.errorCode}
                httpStatusCode={props.errorInfo.httpStatusCode} auth={window.auth}
                logPrefix='CigTenantCreationPage:'>

                <InvalidRegistrationFormMessage />
            </ErrorPage>
        }
        else if (props.errorInfo.errorCode === 1101) {
            const title = 'Trial subscriptions are not available for ' + props.userData.email;
            return <ErrorPage id="invalid-email-error" title={title}  support={false}
                serverMsg={props.errorInfo.errorMessage}
                errorCode={props.errorInfo.errorCode}
                httpStatusCode={props.errorInfo.httpStatusCode} auth={window.auth} logPrefix='CigTenantCreationPage:'>

                <InvalidEmailMessage />
            </ErrorPage>
        }
    }

    if (props.errorInfo.httpStatusCode === 403 && props.isTenantCreationFailed) {
        if (props.errorInfo.errorCode === 1111 || props.errorInfo.errorCode === 1112) {
            const title = 'Data Infrastructure Insights demo tenant is already available for use by NetApp employees.';
            return <ErrorPage id="netapp-user-error" title={title}  support={false} serverMsg={props.errorInfo.errorMessage}
                errorCode={props.errorInfo.errorCode}
                httpStatusCode={props.errorInfo.httpStatusCode} auth={window.auth}
                logPrefix='CigTenantCreationPage:'>

                <NetAppEmployeeRestrictedMessage email={props.userData.email} serviceUrl={BLUEXP_CONFIG[window.CIG.mode].serviceUrl} />
            </ErrorPage>
        }
        else if (props.errorInfo.errorCode === 1101) {
            const title = 'Trial subscriptions are not available for ' + props.userData.email;
            return <ErrorPage id="invalid-email-error" title={title}  support={false}
                serverMsg={props.errorInfo.errorMessage}
                errorCode={props.errorInfo.errorCode}
                httpStatusCode={props.errorInfo.httpStatusCode} auth={window.auth} logPrefix='CigTenantCreationPage:'>

                <InvalidEmailMessage />
            </ErrorPage>
        }
        else if (props.errorInfo.errorCode === 1105) {
            const title = 'Please verify your email before starting a free trial of Data Infrastructure Insights';
            return <ErrorPage id="verified-email-error" title={title} support={false}
                serverMsg={props.errorInfo.errorMessage}
                errorCode={props.errorInfo.errorCode}
                httpStatusCode={props.errorInfo.httpStatusCode} auth={window.auth} logPrefix='CigTenantCreationPage:'>

                <EmailValidatedFailedMessage email={props.userData.email} />
            </ErrorPage>
        }
        else if (props.errorInfo.errorCode === 1113) {
            const title = 'NetApp Single Sign-On is not supported for non-NetApp email addresses';
            return <ErrorPage id="external-netapp-email-error" title={title}  support={false} showReceivedInError={true}
                serverMsg={props.errorInfo.errorMessage} errorCode={props.errorInfo.errorCode}
                httpStatusCode={props.errorInfo.httpStatusCode} auth={window.auth} logPrefix='CigTenantCreationPage:'>

                <SsoNotAllowNonNetAppEmployeeMessage email={props.userData.email} />
            </ErrorPage>
        }
    }

    if (error) {
        const ociSite = _.get(props.newTenantInfo, 'hostname', '') ||  _.get(props.tenants[0], 'hostname', '');
        return <ErrorPage id="access-ci-error" title={'We encountered an error while accessing your Data Infrastructure Insights tenant.'}
            message={`Data Infrastructure Insights: ${ociSite}`} showCIContact={true} logPrefix='CigTenantCreationPage:' serverMsg={ociSite} />
    }
    else if (!_.isEmpty(_.get(props.errorInfo, 'errorMessage', ''))) {
        return <ErrorPage id="server-error" message={props.errorInfo.errorMessage} showCIContact={true} serverMsg={props.errorInfo.errorMessage}
            errorCode={props.errorInfo.errorCode} httpStatusCode={props.errorInfo.httpStatusCode}
            auth={window.auth}
            logPrefix='CigTenantCreationPage:'/>
    }
};

const startTenantCreation = (err, auth, profile, props) => {
    // Add UTM_ here
    let marketingUtmObj = {},
        searchParams = sessionStorage.getItem(MARKETING.campaignSessionKey);

    if (!_.isNil(searchParams)) {
        searchParams = cigDecode(searchParams);
        const jsonObj = getJsonQueryString(searchParams);

        const explicitOptIn = _.get(jsonObj, 'explicitOptIn');
        marketingUtmObj = {
            marketingOptIn: _.isNil(explicitOptIn) ?
                _.get(jsonObj, 'marketingOptIn', false) :
                _.get(jsonObj, 'explicitOptIn', false),
            utmSource: _.get(jsonObj, 'utm_source'),
            utmMedium: _.get(jsonObj, 'utm_medium'),
            utmCampaign: _.get(jsonObj, 'utm_campaign'),
            utmCampaignId: _.get(jsonObj, 'utm_campaign_id'),
            utmContent: _.get(jsonObj, 'utm_content'),
            state: _.get(jsonObj, 'state'),
        };
        sessionStorage.removeItem(MARKETING.campaignSessionKey);
    }

    if (err) {
        const logPrefix = 'CigTenantCreationPage: startTenantCreation: Fail to get auth0 user profile.' +
            ' Marketing Info: ' + marketingUtmObj;

        const error = {
            category: 'ERROR',
            logMessage: logPrefix + ' Error: ' + err,
        };
        serverLog(auth, error);
    }
    /* istanbul ignore else */
    if (!isCookieExisted(CREATE_TENANT_LOCK)) {
        setCookie(CREATE_TENANT_LOCK, Date.now().toString(), CREATING_TENANT_LOCK_COOKIE_MAXAGE);
        // Handle browser refresh
        let location = {};
        if (_.isNil(props.tenantLocation) || _.isEmpty(props.tenantLocation)) {
            location = getTenantLocationLock(auth);
        }
        setTenantLocationLock(props.tenantLocation);
        props.createTenant(auth, 'fakeSubDomain', props.registrationInfo, profile, marketingUtmObj,
            !_.isEmpty(props.tenantLocation) ? props.tenantLocation : location);
    }
    else {
        const info = {
            category: 'INFO',
            logMessage: 'CigTenantCreationPage: startTenantCreation - Skip create tenant. Lock cookie existed',
        };
        serverLog(auth, info);
    }
}


export const resetRefreshId = () => {
    if (!_.isNil(window.autoRefreshId)) {
        window.clearInterval(window.autoRefreshId);
        window.autoRefreshId = undefined;
    }
}

/* istanbul ignore next */
export const setRefreshId = (refreshId) => {
    if (_.isUndefined(window.autoRefreshId)) {
        window.autoRefreshId = refreshId;
    }
}

let is_redirected = false;
export function CigTenantCreationPage(props) {
    const { getUserData, getTenantCreationStatus, auth } = props;
    let newTenantInfo = props.newTenantInfo;
    let errorMessage = props.errorInfo.errorMessage;
    const state = useRef({ newTenantInfo, errorMessage });

    useEffect(() => {
        getUserData(auth);
    }, [getUserData, auth]);

    useEffect(() => {
        state.current = { newTenantInfo, errorMessage };
        if (_.isNil(window.autoRefreshId) && _.isNil(state.current.errorMessage) && _.get(newTenantInfo, 'status') !== 'RUNNING') {
            window.autoRefreshId = setInterval(() => {
                if (!_.isEmpty(_.get(state.current.errorMessage, ''))) {
                    removeCreateTenantCookie(props.userData.subject);
                    resetRefreshId();
                }
                else {
                    const tenantInfo = state.current.newTenantInfo;
                    if (!_.isNil(tenantInfo) && !_.isEmpty(tenantInfo)) {
                        if (_.startsWith(tenantInfo.status, 'FAILED') || _.startsWith(tenantInfo.status, 'DELETED')) {
                            resetRefreshId();
                        }
                        else if (_.get(tenantInfo, 'status') !== 'RUNNING') {
                            getTenantCreationStatus(auth, tenantInfo.tenantId);
                        }
                    }
                    else {
                        getUserData(auth);
                    }
                }
            }, 5000);
        }
    }, [ newTenantInfo, props.errorInfo.errorMessage, auth, getTenantCreationStatus, errorMessage, getUserData, props.userData.subject ]);


    useEffect(() => {
        const ckName = genCookieNameById(props.userData.subject, CREATING_TENANT_COOKIE_PREFIX);
        const {errorStatus, tenantId} = getRedirectTenantInfo(props);
        if (props.tenants.length === 0 && !_.isEmpty(ckName) && _.isUndefined(props.errorInfo.errorMessage) &&
            errorStatus === false && _.isEmpty(tenantId)) {
            if (!isCookieExisted(ckName)) {
                try {
                    setTenantCreationCookie(props.userData);
                }
                catch (e) {
                    /* istanbul ignore next */
                    const logPrefix = 'startTenantCreation: useEffect - Fail to set tenant creation cookie for user: ' +
                        _.isNil(props.userData) ? '' : JSON.stringify(props.userData);
                    /* istanbul ignore next */
                    const creationCookieError = {
                        category: 'ERROR',
                        logMessage: logPrefix + ' Error: ' + e,
                    };
                    /* istanbul ignore next */
                    serverLog(auth, creationCookieError);
                }

                props.getUserProfile(auth, (err, profile) => {
                    startTenantCreation(err, auth, profile, props);
                });
            }
        }
    }, [props.userData, props.tenants, props.registrationInfo, props.tenantLocation, props.getUserProfile, props, auth]);

    const {errorStatus, tenantId, hostName, status, location, uiMode} = getRedirectTenantInfo(props);
    if (errorStatus || status === 'RUNNING' || !_.isEmpty(props.errorInfo.errorMessage)) {
        resetRefreshId();
        const subject = _.get(props.userData,'subject', '');
        removeCreateTenantCookie(subject);
        if (status === 'RUNNING' && !is_redirected) {
            removeTenantLocationLock();
            const redirectRelPath = !_.isNil(uiMode) && uiMode.toUpperCase() === UI_MODE.CM_MODE ? '/web/?' + UI_MODE.KEY + '=' + UI_MODE.CM_MODE : '';
            is_redirected = true;
            props.redirectToTenant(window, auth, tenantId, hostName, redirectRelPath);
        }
    }

    return (
        <div>
            {
                (!_.isEmpty(props.userData) || errorStatus || !_.isUndefined(props.errorInfo.errorMessage)) && renderError(props, errorStatus)
            }
            {
                !_.isEmpty(props.userData) && !_.startsWith(status, 'FAILED') && _.isUndefined(props.errorInfo.errorMessage) && <TenantSpinner
                    id='create_tenant_spinner'
                    name={props.userProfile.name}
                    title={_.isEmpty(props.tenantLocation) ? _.get(location, 'description', '') : _.get(props.tenantLocation, 'description', '')}
                    message={'This might take several minutes. Please be patient while we create your Data Infrastructure Insights tenant.'}
                />
            }
        </div>
    );
}

CigTenantCreationPage.propTypes = {
    errorMessage: PropTypes.string,
    isTenantCreationFailed: PropTypes.bool.isRequired,
    userData: PropTypes.object.isRequired,
    auth: PropTypes.object,
    newTenantInfo: PropTypes.object,
    registrationInfo: PropTypes.object,
    userProfile: PropTypes.object.isRequired,
    errorInfo: PropTypes.object,
    tenantLocation: PropTypes.object,
    tenants: PropTypes.array,
    createTenant: PropTypes.func.isRequired,
    getUserData: PropTypes.func.isRequired,
    getTenantCreationStatus: PropTypes.func.isRequired,
    redirectToTenant: PropTypes.func.isRequired,
    getUserProfile: PropTypes.func.isRequired,
};

CigTenantCreationPage.displayName = 'CigTenantCreationPage';
function mapStateToProps(state){
    return {
        userData: userData(state),
        tenants: userTenantDetailsList(state),
        newTenantInfo: tenantInfo(state),
        isTenantCreationFailed: tenantCreationFailed(state),
        errorInfo: createTenantErrorInfo(state),
        registrationInfo: registrationInfo(state),
        userProfile: userProfileInfo(state),
        tenantLocation: selectedLocation(state),
    }
}

export default connect(
    mapStateToProps,
    {
        createTenant,
        getUserData,
        getTenantCreationStatus,
        redirectToTenant,
        getUserProfile,
    })(CigTenantCreationPage);
